module.exports = __webpack_public_path__ + "static/pic01-32a9f8f534edb25d624431c4642df419.jpg";